import { config } from '@iheartjane/config';
import type { QueryKey } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';

import { api } from '@jane/shared/data-access';

import type { StoreCategory } from './categories';

/**
 * Legacy v1 categories API, used to get list of categories for store specials
 */

const fetchStoreCategories = (storeId: string): Promise<StoreCategory[]> =>
  api.get(`${config.apiPath}/stores/${storeId}/updated_categories`);

export const storeCategoriesQueryOptions = (storeId: string) => {
  const queryKey: QueryKey = ['store_categories_legacy', storeId];
  return queryOptions({
    queryKey,
    queryFn: () => fetchStoreCategories(storeId),
  });
};
